import Vue from 'vue'

export const sharedState = Vue.observable({
    isCenturion: false,
})
